<template>
  <div>
    <!-- <template v-if="channelTypeId !== ChannelType.Voice || $route.params.channel"> -->
    <!--   <a-row v-if="campaign" class="row row__campaign"> -->
    <!--     <a-col class="row__tag"> -->
    <!--       <a-tooltip :title="campaign || null"> -->
    <!--         <a-tag class="tag-custom"> {{ campaign }} </a-tag> -->
    <!--       </a-tooltip> -->
    <!---->
    <!--       <a-tooltip :title="queueName || null"> -->
    <!--         <a-tag> {{ queueName || "..." }} </a-tag> -->
    <!--       </a-tooltip> -->
    <!---->
    <!--       <a-tooltip :title="ticket?.id ? `ID: #${ticket?.id}` : null"> -->
    <!--         <a-tag class="tag-id"> ID: #{{ ticket?.id }} </a-tag> -->
    <!--       </a-tooltip> -->
    <!--     </a-col> -->
    <!--   </a-row> -->

    <!-- <a-row class="row row__actions"> -->
    <!--   <TicketTagsList class="tags-width" withLabel :tags="ticket?.tags" /> -->
    <!---->
    <!--   <div class="ticket__actions"> -->
    <!--     <tag-list -->
    <!--       simple-tag -->
    <!--       has-selected-tickets -->
    <!--       :tickets="[ticket]" -->
    <!--       @update:ticket="$emit('update:ticket')" -->
    <!--     /> -->
    <!---->
    <!--     <Reminder -->
    <!--       :client="client?.name" -->
    <!--       :clientid="client?.id" -->
    <!--       :photo="client?.profile_picture" -->
    <!--     /> -->
    <!---->
    <!--     <SpeechButton :ticket="ticket" /> -->
    <!--   </div> -->
    <!-- </a-row> -->
    <!-- </template> -->
    <a-row class="row row__channels">
      <ChannelsList />

      <div class="row__interactions">
        
        <a-tooltip v-if="ticket?.anchored" title="Ticket anclado">
          <PushpinFilled class="row__pin" />
        </a-tooltip>  
        <div class="info-section" v-if="channelTypeId === ChannelType.Whatsapp || channelTypeId === ChannelType.WhatsappVoice">
          <a-tooltip placement="top" :title="`Interacción ${ channelTypeId === ChannelType.Whatsapp ? 'Whatsapp Message' : 'Whatsapp Voice'}`">
            <component :is="getWhatsappIcon(channelTypeId)" :header="true"></component>
          </a-tooltip>
        </div>
      </div>

      <div class="ticket__actions">
        <a-popover 
          trigger="click" 
          :visible="showPopover" 
          @openChange="handleShowPopover"
          :overlayClassName="'more-popover'"
        >
          <template #content>
            <div class="more-popover">
              <AnchorButton 
                :ticket="ticket" 
                @click="hidePopover"
                @update:ticket="$emit('update:ticket')" 
              />

              <tag-list
                simple-tag
                has-selected-tickets
                :tickets="[ticket]"
                @update:ticket="$emit('update:ticket')"
              />

              <Reminder
                :client="client?.name"
                :clientid="client?.id"
                :photo="client?.profile_picture"
              />

              <SpeechButton :ticket="ticket" @click="hidePopover" />

              <BotVariablesCaptured
                :disabled="!ticket.ticket_variables.length"
                :ticketData="ticket"
                @click="hidePopover"
              />

              <SingleTransfer
                :ticket="ticket"
                @modalIsOpen="transferModalIsOpen = $event"
                :isWorkspace="true"
                :isChat="isChat"
                :inCall="inCall"
              />
            </div>
          </template>

          <a-button class="button" style="padding: 0" type="text">
            <MoreOutlined class="more-icon" />
          </a-button>
        </a-popover>
      </div>
    </a-row>

    <!-- INFO TICKET SECTION -->
    <div class="row row__information">
      <div class="row__content">
        <div class="flex-center-gap-4px border-right" v-if="hasOnlyAlias">
          <component :is="getChannelIcon(interactionSelected?.channel.id)"></component>
          <span>
            {{ alias }}
          </span>
        </div>

        <div class="flex-center-gap-4px border-right" v-else>
          <component :is="getChannelIcon(interactionSelected?.channel.id)"></component>
          <a-tooltip placement="bottom" v-if="phoneNumber !== null">
            <template #title>
              <span> {{ tooltipInfo }} </span>
            </template>
            <span class="identifier">
              {{ alias }}
              <span class="margin-left-6px"> {{ phoneNumber }} </span>
              <component :is="getWhatsappIcon(interactionSelected?.channel.id)"></component>
            </span>
          </a-tooltip>
          <span v-else> Número Aleatorio </span>
        </div>

        <div class="flex-center-gap-4px content-end">
          <a-popover
            v-if="hasContactPopover"
            placement="bottomRight"
            trigger="hover"
            overlayClassName="contact-information-popover"
          >
            <template #content>
              <div class="contact-information">
                <div class="contact-information__item" v-if="whatsappUsername">
                  <span class="contact-information__title">Nombre de usuario en WhatsApp</span>
                  <div class="contact-information__value">
                    <span class="contact-information__username">{{ whatsappUsername }}</span>
                    <CopyButton :value="whatsappUsername" />
                  </div>
                </div>
                <div class="contact-information__item" v-if="whatsappUserId">
                  <span class="contact-information__title">Identificador de WhatsApp (BSUID)</span>
                  <div class="contact-information__value">
                    <span>{{ whatsappUserId }}</span>
                    <CopyButton :value="whatsappUserId" />
                  </div>
                </div>
                <div class="contact-information__item">
                  <span class="contact-information__title">Teléfono del contacto</span>
                  <div class="contact-information__value">
                    <span>{{ contactPhoneNumber || "No compartido" }}</span>
                    <CopyButton v-if="contactPhoneNumber" :value="contactPhoneNumber" />
                  </div>
                </div>
              </div>
            </template>

            <div class="flex-center contact-information__trigger">
              <UserIcon />
              <span class="row__identifier">
                {{ fbClientName ? fbClientName : (phoneIdentifier || whatsappUsername) }}
              </span>
              <InfoCircleOutlined style="margin-left: 4px" />
            </div>
          </a-popover>

          <a-tooltip v-else placement="top" class="flex-center">
            <template #title v-if="hasAliasAndPhoneNumber">
              <span> Teléfono del contacto </span>
            </template>
            <UserIcon />
            <span class="row__identifier">
              {{ fbClientName ? fbClientName : (phoneIdentifier || whatsappUsername) }}
            </span>
          </a-tooltip>
        </div>
      </div>

      <a-row class="row__campaign">
        <a-col class="row__tag">
          <a-tooltip placement="bottom" :title="ticket?.id ? `ID: #${ticket?.id}` : null">
            <a-tag class="tag-id"> #{{ ticket?.id }} </a-tag>
          </a-tooltip>

          <template v-if="campaign">
            <a-tooltip :overlayInnerStyle="{ maxWidth: '136px'}" placement="bottom" :title="campaign ? `Campaña: ${campaign}`: null">
              <a-tag> {{ campaign }} </a-tag>
            </a-tooltip>

            <a-popover placement="bottom" trigger="hover" :transition-name="'none'" overlayClassName="queue-popover">
              <template #content>
                <div class="queue-popover-content">
                  <ul>
                    <li>
                      <span class="label">Cola actual:</span>
                      <span class="value">{{ ticket?.queue?.name || queueName || "..." }}</span>
                    </li>
                    <li>
                      <span class="label">Cola de primera interacción:</span>
                      <span class="value">{{ firstInteractionQueue }}</span>
                    </li>
                  </ul>
                  <a-button type="link" class="more-info-link" @click="handleOpenHelpCenter">Conoce más sobre las colas</a-button>
                </div>
              </template>
              <a-tag style="cursor: pointer"> {{ ticket?.queue?.name || queueName || "..." }} </a-tag>
            </a-popover>
          </template>

          <a-tag class="tag-id">
            {{ interactionTypeLabel }}
          </a-tag>
        </a-col>
      </a-row>
    </div>

    <a-row class="row row__vitiate" v-if="canVitiate">
      <a-button class="button" @click="handleVitiate">
        Llamada equivocada

        <a-tooltip title="Marcar como llamada equivocada">
          <InfoCircleOutlined />
        </a-tooltip>
      </a-button>
    </a-row>

    <a-drawer
      v-model:visible="visibleHelpDrawer"
      class="info-drawer"
      placement="right"
      :closable="false"
      :width="420"
    >
      <template #title>
        <header class="info-drawer-header">
          <span class="title">Centro de ayuda</span>

          <a-button type="text" class="button button__close" @click="visibleHelpDrawer = false">
            <CloseOutlined class="icon" />
          </a-button>
        </header>
      </template>

      <HelpCenterComponent
        v-if="visibleHelpDrawer"
        :data="workspaceHelpData"
        default-open-title="Cola actual y cola de primera interacción"
      />

      <template #footer>
        <footer class="info-drawer-footer">
          <a-button class="support" :href="supportUrl" target="_blank">Ir a Soporte</a-button>
          <a-button @click="visibleHelpDrawer = false"> Cerrar </a-button>
        </footer>
      </template>
    </a-drawer>
  </div>
</template>

<script>
import { createVNode, inject, ref } from "vue";

import { Modal, message } from "ant-design-vue";
import { InfoCircleOutlined, QuestionCircleOutlined, MoreOutlined, PushpinFilled, CloseOutlined } from "@ant-design/icons-vue";
import UserIcon from "@/app/shared/components/icons/UserIcon.vue";
import VoiceIcon from "@/app/shared/components/icons/channelIcons/VoiceIcon.vue";
import WhatsappIcon from "@/app/shared/components/icons/channelIcons/WhatsappIcon.vue";
import FacebookMsnIcon from "@/app/shared/components/icons/channelIcons/FacebookMsnIcon.vue";
import InstagramIcon from "@/app/shared/components/icons/channelIcons/InstagramIcon.vue";
import WebchatIcon from "@/app/shared/components/icons/channelIcons/WebchatIcon.vue";
import SmsIcon from "@/app/shared/components/icons/channelIcons/SmsIcon.vue";
import IconWhatsappChatGrey from "@/app/shared/components/icons/IconWhatsappChatGrey.vue";
import IconWhatsappCallGrey from "@/app/shared/components/icons/IconWhatsappCallGrey.vue";
import CopyButton from "@/app/shared/components/buttons/CopyButton.vue";

import { ChannelType, InteractionType } from "@/app/shared/utils/enums";
import { vitiateIncomingCall } from "@/app/workspace/services";
import EventBus from "@/app/shared/utils/eventBus";
import { WorkspaceEvent } from "@/app/workspace/domain/events";

import Reminder from "@/app/workspace/components/modal/Reminder.vue";
import TagList from "@/app/workspace/components/filters/TagList.vue";
import SingleTransfer from "@/app/workspace/components/filters/SingleTransfer.vue";

// import TicketTagsList from "@/app/shared/components/lists/TicketTagsList.vue";
import SpeechButton from "@/app/workspace/components/buttons/SpeechButton.vue";
import ChannelsList from "@/app/workspace/components/lists/ChannelsList.vue";
import BotVariablesCaptured from "./BotVariablesCaptured.vue";
import AnchorButton from "@/app/workspace/components/buttons/AnchorButton.vue";
import { validateActionByState } from "@/app/shared/composables/useRegisterEventManagement.ts";
import { supportUrl } from "@/app/common/components/organisms/TheSidebar/items";
import HelpCenterComponent from "@/app/entities/components/helpCenter/index.vue";

const WORKSPACE_HELP_DATA = {
  type: "menu_workspace",
  items: [
    {
      id: 1,
      order: 1,
      title_menu: "Cola actual y cola de primera interacción",
      subtitle_menu: "¿Cuál es la diferencia entre estas colas?",
      show_submenu: true,
      information: {
        title: "",
        icon: null,
        content: [
          {
            title: "Cola actual",
            text: "Es la cola donde se encuentra el ticket en este momento. Esta información se actualiza cada vez que el ticket es transferido a nueva cola dentro de la campaña.",
            image: null,
            order: 1
          },
          {
            title: "Cola de primera interacción",
            text: "Es la cola donde se registró la primera interacción por parte del contacto vía mensajería o llamada. Esta información no cambia en todo el período de vida del ticket.",
            image: null,
            order: 2
          }
        ]
      }
    }
  ]
};

export default {
  components: {
    Reminder,
    TagList,
    SingleTransfer,
    InfoCircleOutlined,
    ChannelsList,
    // TicketTagsList,
    SpeechButton,
    MoreOutlined,
    BotVariablesCaptured,
    UserIcon,
    VoiceIcon,
    WhatsappIcon,
    FacebookMsnIcon,
    InstagramIcon,
    WebchatIcon,
    SmsIcon,
    AnchorButton,
    PushpinFilled,
    HelpCenterComponent,
    CloseOutlined,
    CopyButton,
  },
  props: {
    isChat: { required: false, type: Boolean },
    inCall: Boolean,
  },
  data() {
    return {
      ChannelType,
      showPopover: false,
      interactionSelected: null,
      transferModalIsOpen: null,
      visibleHelpDrawer: false,
      supportUrl,
      workspaceHelpData: WORKSPACE_HELP_DATA,
    };
  },
  setup() {
    const ticket = inject("selectedTicket");
    const channel = inject("selectedChannel");
    const ticketInteractionsChannels = inject("ticketInteractionsChannels", ref([]));

    return { ticket, channel, ticketInteractionsChannels };
  },
  methods: {
    handleOpenHelpCenter() {
      this.visibleHelpDrawer = true;
    },
    async handleShowPopover() {
      await validateActionByState(this.dataUserState);
      this.showPopover = !this.showPopover;
    },
    hidePopover() {
      this.showPopover = false;
    },
    getTagColor(color) {
      return `background-color: #${color}`;
    },
    async handleVitiate() {
      Modal.confirm({
        title: "¿Deseas terminar la llamada y guardarla como equivocada?",
        content: "Recuerda que al guardar se finalizará la llamada inmediatamente.",
        icon: createVNode(QuestionCircleOutlined),
        centered: true,
        okText: "Guardar",
        onOk: async () => {
          try {
            const body = {
              phoneNumber: this.channel?.identifier || this.ticket?.identifier,
              ticket: Number(this.$route.query.ticket),
              asterisk_id: this.$jssip.phone.meta?.asteriskId,
            };

            this.$jssip.end({ fromTypification: true });
            EventBus.$emit(WorkspaceEvent.TICKET_CLOSED, { resolveWithoutTypification: true });
            await vitiateIncomingCall(body);
            message.success("Guardado como llamada equivocada correctamente");
            // this.$jssip.reset();
          } catch (e) {
            console.log(e);
            message.error("Ha ocurrido un error");
          }
        },
      });
    },
    getChannelIcon(type) {
      switch (type) {
        case ChannelType.Voice:
        case ChannelType.Ivr:
        case ChannelType.VoiceInbound:
          return VoiceIcon;
        case ChannelType.Whatsapp:
          return WhatsappIcon;
        case ChannelType.Messenger:
          return FacebookMsnIcon;
        case ChannelType.Instagram:
          return InstagramIcon;
        case ChannelType.Inbound:
          return WebchatIcon;
        case ChannelType.Sms:
          return SmsIcon;
        case ChannelType.WhatsappVoice:
          return WhatsappIcon;
        default:
          return null;
      }
    },
    getWhatsappIcon(type) {
      switch (type) {
        case ChannelType.Whatsapp:
          return IconWhatsappChatGrey;
        case ChannelType.WhatsappVoice:
          return IconWhatsappCallGrey;
        default:
          return null;
      }
    },
    getCurrentIntData() {
      if (this.interactions) {
        const int = parseInt(this.$route.query.interaction);

        const msgInteraction = this.interactions.messages.find(
          (interaction) => interaction.id === int
        );

        const voiceInteraction = this.interactions.voice.find(
          (interaction) => interaction.id === int
        );

        const whatsappVoiceInteraction = this.interactions.whatsapp_voice.find(
          (interaction) => interaction.id === int
        );

        if (msgInteraction) {
          this.interactionSelected = { ...msgInteraction, typeInteraction: "message" };
        }

        if (voiceInteraction) {
          this.interactionSelected = { ...voiceInteraction, typeInteraction: "voice" };
        }

        if (whatsappVoiceInteraction) {
          this.interactionSelected = { ...whatsappVoiceInteraction, typeInteraction: "whatsapp_voice" };
        }

      }
    },
    formattedPhoneNumber(number) {
      if (number !== null) {
        const sliced = number.length <= 7 ? `+${number}` : `+${number.slice(0, 7)}` + "...";

        return {
          number,
          sliced,
        };
      }
    },
  },
  computed: {
    dataUserState() {
      return this.$store.getters["getDataUserState"];
    },
    tooltipInfo() {
      if (this.channel?.channel?.id === ChannelType.Whatsapp) {
        return `WA Message de tu empresa: ${this.alias} (${this.phoneNumber})`
      }
      if (this.channel?.channel?.id === ChannelType.WhatsappVoice) {
        return `WA Voice de tu empresa: ${this.alias} (${this.phoneNumber})`
      }
      return this.alias !== ""
        ? `Identificador de tu empresa: ${this.alias} ${this.phoneNumber}`
        : null;
    },
    interactions() {
      return this.$store.getters["getInteractionsChannel"];
    },
    currentInteraction() {
      return this.$route.query.interaction;
    },
    isVoice() {
      return (
        this.channel?.channel?.id === ChannelType.Voice ||
        this.channel?.channel?.id === ChannelType.VoiceInbound
      );
    },
    fbClientName() {
      return this.interactionSelected?.extra_information?.fullname;
    },
    whatsappUsername() {
      const username =
        this.interactionSelected?.whatsapp_username ||
        this.channel?.whatsapp_username ||
        this.ticket?.whatsapp_username;
      if (!username) return null;
      const trimmed = String(username).trim();
      return trimmed.startsWith("@") ? trimmed : `@${trimmed}`;
    },
    whatsappUserId() {
      return (
        this.interactionSelected?.whatsapp_user_id ||
        this.channel?.whatsapp_user_id ||
        this.ticket?.whatsapp_user_id ||
        null
      );
    },
    hasContactPopover() {
      return Boolean(
        !this.fbClientName &&
        (this.whatsappUsername || this.whatsappUserId)
      );
    },
    contactPhoneNumber() {
      const phone = this.phoneIdentifier || this.interactionSelected?.identifier || this.identifier;
      if (
        !phone ||
        phone === "null" ||
        phone === "undefined" ||
        String(phone).trim() === "" ||
        String(phone).trim().startsWith("@")
      ) {
        return null;
      }
      return phone;
    },
    // ticket() {
    //   const tickets = this.$store.getters["getWorkspaceTickets"];
    //   const ticketId = this.$route.params.ticket;
    //   return tickets.find((item) => item.id == ticketId);
    // },
    client() {
      return this.ticket?.client;
    },
    channelTypeId() {
      return this.channel?.channel?.id || this.ticket?.channel?.id;
    },
    firstInteraction() {
      const interactions = this.ticketInteractionsChannels || [];
      if (!interactions.length) return null;

      const sorted = [...interactions].sort((a, b) => {
        if (a.created_at && b.created_at) {
          return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
        }
        return (a.id || 0) - (b.id || 0);
      });

      return sorted[0];
    },
    interactionTypeLabel() {
      // 1. Verificar por el primer mensaje del historial del ticket
      const historyData = this.$store.getters["getWorkspaceMessageHistory"];
      const messagesList = [];
      const historyItems = historyData?.history || (Array.isArray(historyData) ? historyData : []);
      
      if (Array.isArray(historyItems)) {
        historyItems.forEach((group) => {
          if (group?.messages && Array.isArray(group.messages)) {
            messagesList.push(...group.messages);
          }
        });
      }

      if (messagesList.length > 0) {
        const sortedMessages = [...messagesList].sort((a, b) => {
          const dateA = new Date(a.created_at || a.date || 0).getTime();
          const dateB = new Date(b.created_at || b.date || 0).getTime();
          if (dateA !== dateB) return dateA - dateB;
          return (a.id || 0) - (b.id || 0);
        });

        const firstMsg = sortedMessages[0];
        if (firstMsg) {
          const isFromAgent = firstMsg.origin === "agent" || firstMsg.created_by_agent;
          return isFromAgent ? "Outbound" : "Inbound";
        }
      }

      // 2. Fallback a firstInteraction
      const firstType = this.firstInteraction?.type_interaction;

      if (firstType === InteractionType.Inbound || firstType === 1) {
        return "Inbound";
      }

      if (firstType === InteractionType.Outbound || firstType === 2) {
        return "Outbound";
      }

      // 3. Fallback al tipo de interacción actual
      const currentType = this.channel?.type_interaction;

      if (currentType === InteractionType.Inbound) {
        return "Inbound";
      }

      if (currentType === InteractionType.Outbound) {
        return "Outbound";
      }

      return [ChannelType.VoiceInbound, ChannelType.WhatsappVoice].includes(this.channelTypeId)
        ? "Inbound"
        : "Outbound";
    },
    campaign() {
      const data = this.$store.getters["getWorkspaceMessageHistory"];
      return this.ticket?.portfolio?.name || data?.ticket?.portfolio?.name;
    },
    queueName() {
      const history = this.$store.getters["getWorkspaceMessageHistory"];
      return this.channel?.queue_name || this.ticket?.queue?.name || history?.ticket?.queue?.name;
    },
    firstInteractionQueue() {
      const interactions = this.ticketInteractionsChannels || [];
      if (!interactions.length) {
        return "Sin cola";
      }

      const sorted = [...interactions].sort((a, b) => {
        if (a.created_at && b.created_at) {
          return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
        }
        return (a.id || 0) - (b.id || 0);
      });

      // Busca la primera interacción que tenga cola Y que haya sido efectivamente contestada / establecida
      const firstWithQueue = sorted.find((item) => {
        const queueName = item?.queue_name || item?.queue?.name;
        if (!queueName) return false;

        const isOutbound =
          item?.type_interaction === InteractionType.Outbound ||
          item?.type_interaction === 2;

        if (isOutbound) {
          const isPhoneCall =
            [ChannelType.Voice, ChannelType.VoiceInbound, ChannelType.Ivr].includes(item?.channel?.id) ||
            item?.channel?.is_phone_outbound;

          if (isPhoneCall) {
            const isPhoneInCall = this.$jssip?.phone?.status === "in-call";
            const isCurrentCall = this.$jssip?.phone?.isCurrentCallTicket?.(this.ticket?.id);
            return Boolean(item?.contact_date || (isCurrentCall && isPhoneInCall));
          }

          // Para mensajes salientes (ej. WhatsApp): requiere que el cliente haya respondido
          return Boolean(this.ticket?.answer_by_client || item?.contact_date || item?.first_answer_date);
        }

        return true;
      });

      if (!firstWithQueue) {
        return "Sin cola";
      }

      return firstWithQueue.queue_name || firstWithQueue.queue.name;
    },
    phoneIdentifier() {
      // Si ya se resolvio la interaccion activa (misma fuente que whatsappUsername
      // y whatsappUserId), se confia en SU identifier aunque venga vacio: un
      // ticket puede agrupar mas de una interaccion de WhatsApp y ticket.identifier
      // puede traer el telefono de OTRA interaccion (propagacion CU-86e30a03u).
      const identifier = this.interactionSelected
        ? this.interactionSelected?.identifier
        : (this.channel?.identifier || this.ticket?.identifier);
      if (
        !identifier ||
        identifier === "null" ||
        identifier === "undefined" ||
        String(identifier).trim() === "" ||
        String(identifier).trim().startsWith("@")
      ) {
        return null;
      }
      const codeCountry = this.channel?.code_country;
      return codeCountry ? `+${codeCountry}${identifier}` : identifier;
    },
    identifier() {
      const history = this.$store.getters["getWorkspaceMessageHistory"];
      const client = history?.ticket?.client;
      const message = history?.history?.[0]?.messages?.[0];
      return client?.name || message?.identifier;
    },
    canVitiate() {
      return [ChannelType.VoiceInbound, ChannelType.WhatsappVoice].includes(this.channelTypeId) && !this.$route.query.client;
    },
    alias() {
      return this.interactionSelected?.channel_customer.alias || "";
    },
    phoneNumber() {
      return this.interactionSelected?.channel_customer?.data_parameters?.phone_number || null;
    },
    hasAliasAndPhoneNumber() {
      return [ChannelType.Voice, ChannelType.Whatsapp].includes(this.channelTypeId) && this.phoneIdentifier;
    },
    hasOnlyAlias() {
      return [ChannelType.Messenger, ChannelType.Instagram, ChannelType.Inbound].includes(
        this.channelTypeId
      );
    },
  },
  watch: {
    interactions() {
      this.getCurrentIntData();
    },
    currentInteraction: {
      immediate: true,
      handler: function () {
        this.getCurrentIntData();
      },
    },
    transferModalIsOpen(newValue) {
      if (newValue) {
        this.hidePopover();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.row
  padding: 8px 12px
  background-color: white

  &__tag
    display: flex
    align-items: center
    gap: 4px
    font-size: 12px

    & > *
      margin: 0

  &__content
    display: flex
    font-weight: 600
    margin-bottom: 8px

  &__information
    background-color: #F2F5F7
    border-bottom: $border-medium
    color: $gray-8

  &__channels
    border-bottom: $border-medium
    display: flex
    justify-content: space-between

  &__campaign
    font-size: 12px
    display: block
    align-items: center
    justify-content: space-between

  &__actions
    border-bottom: $border-medium
    min-height: 40px
    max-height: 40px
    padding-top: 0
    padding-bottom: 0
    display: flex
    justify-content: space-between

  &__identifier
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    max-width: 230px
    text-transform: capitalize

  &__vitiate
    background-color: #f0f2f5
    display: flex
    justify-content: center
    align-items: center
    border-bottom: $border-medium
  
  &__pin
    color: #F5222D 
    font-size: 16px
    padding: 0 8px

  &__interactions
    display: flex
    align-items: center
    border-left: $border-medium
    margin-left: auto

.tag
  &-custom
    background-color: #F0F5FF
    color: $geekblue-7
    border-color: #ADC6FF

  &-id
    overflow: inherit !important

.ticket
  &__tags
    padding-right: 8px
    display: flex
    align-items: center
    flex-wrap: wrap
    gap: 0 4px
    max-height: 40px

  .tags-width
    max-width: calc(100% - 54px)

  &__message
    color: $gray-6
    font-style: italic
    font-size: 12px

  &__actions
    border-left: $border-medium
    display: flex
    align-items: center
    padding-left: 8px
    gap: 8px

.color-tag
  width: 20px
  height: 8px
  border-radius: 2px
  border: $white

:deep(.ant-tag)
  overflow: hidden
  text-overflow: ellipsis

.button
  height: 24px
  padding: 0 8px

.more
  &-icon
    font-size: 20px
    color: $gray-8

  &-popover
    display: flex
    flex-direction: column
    gap: 4px

.ant-tooltip-open
  font-size: inherit !important

.border-right
  border-right: 1px solid #D9D9D9

.flex-center-gap-4px
  display: flex
  align-items: center
  gap: 4px
  flex: 1
  min-width: 0px

.content-end
  justify-content: end

.identifier
  margin-bottom: 0px
  overflow: hidden
  white-space: nowrap
  text-overflow: ellipsis

  // &::after
  //   content: '...'
  //   position: absolute
  //   bottom: 0
  //   right: 0
  //   background: #F2F5F7
  //   color: #00000073
  //   padding-left: 2px

  span
    margin-left: 6px
    font-size: 12px
    font-weight: 500
    color: #00000073

  svg
    margin-left: 6px
    vertical-align: middle

.flex-center
  display: flex
  align-items: center

  .anticon
    margin-right: 4px

.info-section
  padding: 0 8px

.info-drawer-header
  display: flex
  justify-content: space-between
  align-items: center
  .title
    font-size: 24px
  .button__close
    width: 32px
    padding: 0
    .icon
      font-size: 16px

.info-drawer-footer
  display: flex
  justify-content: space-between
  width: 100%
  .support
    border: none
    box-shadow: none
    color: #1890ff

.contact-information
  display: flex
  flex-direction: column
  gap: 12px
  min-width: 220px

  &__item
    display: flex
    flex-direction: column
    color: $gray-8
    line-height: 20px

    span
      font-weight: 400
      font-size: 13px

  &__trigger
    cursor: default
    min-width: 0

    .row__identifier
      display: block
      max-width: 180px
      overflow: hidden
      white-space: nowrap
      text-overflow: ellipsis

  &__value
    display: flex
    align-items: center
    gap: 4px

  &__username
    display: block
    max-width: 180px
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis

  &__title
    font-weight: 600 !important
    color: $gray-9 !important
</style>

<style lang="sass">
.row__tag
  .ant-tag
    &, &:hover, &.ant-popover-open, &.ant-tooltip-open
      font-size: 12px !important
      height: 22px !important
      line-height: 20px !important
      padding: 0 7px !important
      border-color: #d9d9d9 !important
      box-shadow: none !important
      background-color: #fafafa !important
      color: rgba(0, 0, 0, 0.85) !important
      transform: none !important
      transition: none !important
      animation: none !important

.queue-popover
  max-width: 280px
  &, & *, &::before, &::after, *::before, *::after
    transition: none !important
    animation: none !important
    animation-duration: 0s !important
    transition-duration: 0s !important
  .ant-popover-inner-content
    padding: 12px 16px
  .queue-popover-content
    font-size: 14px
    color: #262626
    ul
      list-style-type: disc
      padding-left: 16px
      margin-bottom: 8px
      li
        margin-bottom: 4px
    .label
      font-weight: 600
      display: block
      margin-bottom: 2px
    .value
      display: block
      color: #595959
      margin-bottom: 4px
    .more-info-link
      padding: 0
      height: auto
      color: #1890FF
      font-size: 14px
      &:hover
        color: #40a9ff
</style>
